<template>
  <div class="modal-goodslist">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;"></div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <template>
          <el-table :data="tableData" height="400" border>

            <el-table-column prop="checkinAssessGroupName" label="选项名称"></el-table-column>

            <el-table-column prop="checkinAssessItemName" label="选项"></el-table-column>

            <el-table-column prop="fraction" label="分值"></el-table-column>

          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "myInfo",
  data() {
    return {
      tableData:[],
      th:0,
    }
  },

  methods: {
    init(value){
      console.log(value);
      this.tableData = value;
    },
    closeSelf() {
      this.$emit("closeInfo");
    },

  }
}
</script>

<style  lang="scss" scoped>

.modal-goodslist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width:500px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body {
      position: relative;
      padding: 20px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}
</style>
